import { Shape } from "three";
import { archNotch } from "../geometry/arch";
import { straightRun } from "../geometry/path";
import { BUS, BUS_ARCH_RADIUS, BUS_NOSE_X, BUS_TAIL_X } from "./dimensions";
function busBodyProfile() {
  const { skirtY, roofY, wheelRadius, steerAxleX, driveAxleX } = BUS;
  const [screenLowX, screenLowY] = BUS.windscreenLower;
  const [screenHighX, screenHighY] = BUS.windscreenUpper;
  const s = new Shape();
  s.moveTo(BUS_TAIL_X + 0.16, skirtY);
  for (const axleX of [driveAxleX, steerAxleX]) {
    archNotch(s, { axleX, hubY: wheelRadius, radius: BUS_ARCH_RADIUS, edgeY: skirtY });
  }
  straightRun(s, BUS_NOSE_X - 0.16, skirtY);
  s.quadraticCurveTo(BUS_NOSE_X, skirtY, BUS_NOSE_X, skirtY + 0.35);
  straightRun(s, screenLowX, screenLowY);
  straightRun(s, screenHighX, screenHighY);
  s.quadraticCurveTo(screenHighX - 0.18, roofY, screenHighX - 0.46, roofY);
  straightRun(s, BUS_TAIL_X + 0.42, roofY);
  s.quadraticCurveTo(BUS_TAIL_X, roofY, BUS_TAIL_X, roofY - 0.46);
  straightRun(s, BUS_TAIL_X + 0.05, skirtY + 0.35);
  s.quadraticCurveTo(BUS_TAIL_X + 0.05, skirtY, BUS_TAIL_X + 0.16, skirtY);
  return s;
}
export {
  busBodyProfile
};
